const portalId = process.env.REACT_APP_HUBSPOT_PORTAL_ID;
const formGuid = process.env.REACT_APP_HUBSPOT_FORM_GUID;

const readCookie = (name) => {
  const row = document.cookie
    .split("; ")
    .find((item) => item.startsWith(`${name}=`));
  return row ? decodeURIComponent(row.slice(name.length + 1)) : undefined;
};

export async function submitEnquiry({ name, email, countries, message }) {
  const fields = [
    { name: "email", value: email.trim() },
    { name: "firstname", value: name.trim() },
    { name: "countries_touched", value: countries.trim() },
    { name: "message", value: message.trim() },
    { name: "lead_source", value: "Family Office" },
  ];

  const hutk = readCookie("hubspotutk");
  const context = {
    pageUri: window.location.href,
    pageName: document.title,
    ...(hutk ? { hutk } : {}),
  };

  const response = await fetch(
    `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ fields, context }),
    }
  );

  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw new Error(
      (body && body.errors && body.errors[0] && body.errors[0].message) ||
        `Submission failed (${response.status})`
    );
  }

  return response.json().catch(() => null);
}
